exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* #ffffff */ /* #F9F9F9 */ /* #D9E3F2 */ /* 90% transparent version of motion-primary */ /* #2F2E2E */ /* #FFFFFF */ /* 25% transparent version of ui-white */ /* 15% transparent version of black */ /* #696D6F */ /*#FFFFFF*/ /* #425077 */ /* #3373CC */ /* 35% transparent version of motion-primary */ /* 10% transparent version of motion-primary */ /* #FF661A */ /* #E64D00 */ /* #CF63CF */ /* #BD42BD */ /* #FFAB19 */ /* #FF8C1A */ /* #0FBD8C */ /* #0FBD8C */ /* #FF8C1A */ /* #FF8C1A */ /* #0FBD8C */ /* #0B8E69 */ /* 35% transparent version of extensions-primary */ .loupe_color-picker_1OaU- {\n    position: absolute;\n    border-radius: 100%;\n    border: 4px solid hsla(0, 0%, 0%, 0.15);\n}\n", ""]);

// exports
exports.locals = {
	"color-picker": "loupe_color-picker_1OaU-",
	"colorPicker": "loupe_color-picker_1OaU-"
};